import { Control, Language, Service } from '@yleisradio/areena-types';

const languageSwapControl: Record<Language, Control> = {
  fi: {
    functionality: {
      id: 'languageChange',
    },
    title: 'På svenska',
    type: 'activator',
  },
  sv: {
    functionality: {
      id: 'languageChange',
    },
    title: 'Suomeksi',
    type: 'activator',
  },
};

type ControlsByLanguage = Record<Language, Control[]>;

const shortcutDataTV: ControlsByLanguage = {
  fi: [
    {
      destination: {
        uri: '/tv/ohjelmat/kaikki',
      },
      title: 'Kaikki TV-ohjelmat',
      type: 'navigator',
    },
    {
      destination: {
        uri: '/tv/ohjelmat/kaikki?gr=false',
      },
      title: 'Katsottavissa ulkomailla',
      type: 'navigator',
    },
    languageSwapControl['fi'],
  ],
  sv: [
    {
      destination: {
        uri: '/tv/program/alla',
      },
      title: 'Alla tv-program',
      type: 'navigator',
    },
    {
      destination: {
        uri: '/tv/program/alla?gr=false',
      },
      title: 'Kan ses utomlands',
      type: 'navigator',
    },
    languageSwapControl['sv'],
  ],
};

export const shortcutData: Record<Service, ControlsByLanguage> = {
  tv: shortcutDataTV,
  radio: {
    fi: [languageSwapControl['fi']],
    sv: [languageSwapControl['sv']],
  },
};
